export default {
    TERMINOS_ACEPTADOS: 'TERMINOS_ACEPTADOS',
    FETCH_LEGAL: 'FETCH_LEGAL',
    FETCH_LEGAL_SUCCESS: 'FETCH_LEGAL_SUCCESS',
    OPEN_YESNO_MODAL: 'OPEN_YESNO_MODAL',
  }